export default defineNuxtPlugin(() => {
  const {api: {baseUrl}} = useAppConfig();

  const apiFetch = <R>(path: string, opts: any = {}) => {
    if (import.meta.client) {
      const telegramData = useTelegramWebApp()?.initData;

      if (telegramData) {
        opts = opts || {};

        opts.headers = {
          'X-Telegram-Web-App-Data': telegramData,
          ...opts.headers,
        }
      }
    }

    return $fetch<R>(path, {baseURL: baseUrl, ...opts});
  };

  return {
    provide: {apiFetch}
  };
});
